module.exports = new __parcel__URL__("loading-file-error.402df2c9.svg").toString();